const PainelOAB = () => {

    return (
        <div className="container">
            <div className="card">
                <h1>PainelOAB</h1>
                <hr />
                <a 
                    href="https://pje.oabma.org.br/" 
                    target="_blank" 
                    rel="noopener noreferrer">
                        PJe OAB
                </a>
            </div>
        </div>
    );
}
export default PainelOAB
